import { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export const useHorizontalScroll = (
  classPairs: { wrapperClass: string; itemClass: string }[] = [
    { wrapperClass: '.services-scroll-wrapper', itemClass: '.services-scroll-item' },
    { wrapperClass: '.testimonial-scroll-wrapper', itemClass: '.testimonial-scroll-item' }
  ]
) => {
  useEffect(() => {
    if (window.innerWidth < 768) return;

    gsap.registerPlugin(ScrollTrigger);

    const timelines: gsap.core.Tween[] = [];

    classPairs.forEach(({ wrapperClass, itemClass }) => {
      const container = document.querySelector<HTMLElement>(wrapperClass);
      const sections = gsap.utils.toArray<HTMLElement>(itemClass);

      if (!container || sections.length === 0) return;

      const totalWidth = sections.reduce((acc, section) => acc + section.offsetWidth, 0);
      const wrapperWidth = container.offsetWidth;
      const initialOffset = wrapperWidth * 0.5;

      gsap.set(container, {
        x: initialOffset,
      });

      const timeline = gsap.to(container, {
        x: -1 * (totalWidth - wrapperWidth + initialOffset),
        ease: 'none',
        scrollTrigger: {
          trigger: container,
          pin: true,
          invalidateOnRefresh: true,
          start: 'center center',
          scrub: 1,
          end: () => `+=${totalWidth}`,
        },
      });

      timelines.push(timeline);
    });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
      timelines.forEach(tl => tl.kill());
    };
  }, [classPairs]);
};
